// extracted by mini-css-extract-plugin
module.exports = {"shopini-logistics":"styles_shopini-logistics__2GZ99","title":"styles_title__2S0TD","sub-title":"styles_sub-title__1lSWQ"};